export default __webpack_public_path__ + "static/media/14_box 2.efbfc8e8.gif";